import { createSlice } from '@reduxjs/toolkit';
import {
  EarningHistoryModel,
  EarningInfoModel,
  EarningModel
} from '../views/Earnings/Earnings.types';
import {
  getEarningDetails,
  getEarningHistory,
  initEarnings
} from '../views/Earnings/Earnings.actions';
import {
  EarnBetResponse,
  GetWithdrawAvailabilityResponse
} from '../views/Earnings/Withdraw/Withdraw.types';

import {
  exchangeUsdtToClub,
  exchangeUsdtToMLP,
  exchangeClubToMLP
} from '../views/Earnings/TopUp/TopUp.actions';
import {
  transferToEarnBet,
  checkEarnBetUser
} from '../views/Earnings/TranferToEarnBet/Transfer.actions';

export interface accountingSliceType {
  loading: boolean;
  loadingHistory: boolean;
  history: EarningHistoryModel[];
  info: EarningInfoModel | null;
  earnbetUserExists: boolean;
  hasPaidDeposit: boolean;
  earningDetails: EarningModel | null;
  withdrawAvailability: GetWithdrawAvailabilityResponse | null;
  userEarnbetTopup: EarnBetResponse | null;
}

const initialState = {
  loading: false,
  loadingHistory: false,
  history: [],
  info: null,
  earnbetUserExists: false,
  hasPaidDeposit: false,
  earningDetails: null,
  withdrawAvailability: null,
  userEarnbetTopup: null
} as accountingSliceType;

const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    changeAvailableBalance(state, { payload }) {
      if (state.info) {
        state.info.totalEarnings.availableBalance =
          state.info.totalEarnings.availableBalance - payload;
      }
    },
    removeEarningsState(state) {
      state = initialState;
    }
  },

  extraReducers: (builder) => {
    builder.addCase(initEarnings.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(initEarnings.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.info = payload.info;
      state.history = payload.history || [];
      state.withdrawAvailability = payload.withdrawAvailability || null;
    });
    builder.addCase(initEarnings.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getEarningHistory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEarningHistory.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.history = payload || [];
    });
    builder.addCase(getEarningHistory.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getEarningDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEarningDetails.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.earningDetails = payload || null;
    });
    builder.addCase(getEarningDetails.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(exchangeUsdtToClub.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(exchangeUsdtToClub.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.info!.totalEarnings.availableBalance =
        payload.availableRewardPoints;
      state.info!.totalEarnings.shoppingPoints = payload.shoppingPoints;
    });
    builder.addCase(exchangeUsdtToClub.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(exchangeUsdtToMLP.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(exchangeUsdtToMLP.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.info!.totalEarnings.availableBalance =
        payload.availableRewardPoints;
      state.info!.totalEarnings.myLifePoints = payload.myLifePoints;
    });
    builder.addCase(exchangeUsdtToMLP.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(exchangeClubToMLP.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(exchangeClubToMLP.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.info!.totalEarnings.shoppingPoints = payload.shoppingPoints;
      state.info!.totalEarnings.myLifePoints = payload.myLifePoints;
    });
    builder.addCase(exchangeClubToMLP.rejected, (state) => {
      state.loading = false;
    });

    //transfer to earnbet
    builder.addCase(transferToEarnBet.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(transferToEarnBet.fulfilled, (state, { payload }) => {
      state.loading = false;

      if (!payload?.isEarnBetTransfer) {
        state.info!.totalEarnings.availableBalance =
          payload?.userTickets.availableRewardPoints;
        state.info!.totalEarnings.shoppingPoints =
          payload?.userTickets.shoppingPoints;
      }

      state.userEarnbetTopup = payload?.userEarnbetTopup;
    });

    builder.addCase(transferToEarnBet.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(checkEarnBetUser.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(checkEarnBetUser.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.earnbetUserExists = payload.earnbetUserExists;
      state.hasPaidDeposit = payload.hasPaidDeposit;
    });
    builder.addCase(checkEarnBetUser.rejected, (state) => {
      state.loading = false;
    });
  }
});

export const { changeAvailableBalance, removeEarningsState } =
  ordersSlice.actions;

export default ordersSlice.reducer;
